import React, { useState } from "react";
import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/UI";
import { IconMail, IconPhone, IconPin, IconCheckCircle } from "../components/Icons";

export function Contact() {
  const [sent, setSent] = useState(false);

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Demo landing: no backend submission yet — acknowledge locally.
    setSent(true);
  };

  return (
    <>
      <PageHero
        eyebrow="Liên hệ"
        title="Đặt lịch demo hoặc trao đổi nhu cầu triển khai"
        sub="Để lại thông tin, đội ngũ Ghi Âm Pro sẽ liên hệ tư vấn và demo trên tình huống họp thực tế của đơn vị bạn."
      />

      <section className="section">
        <div className="container contact-grid">
          <Reveal>
            {sent ? (
              <div className="card" style={{ textAlign: "center", padding: "44px 28px" }}>
                <div className="ic teal" style={{ margin: "0 auto 14px" }}>
                  <IconCheckCircle size={26} />
                </div>
                <h3>Đã ghi nhận yêu cầu của bạn</h3>
                <p style={{ marginTop: 8 }}>
                  Cảm ơn bạn đã quan tâm Ghi Âm Pro. Chúng tôi sẽ liên hệ lại trong thời gian sớm
                  nhất để sắp xếp buổi demo.
                </p>
                <button className="btn btn-ghost" style={{ marginTop: 20 }} onClick={() => setSent(false)}>
                  Gửi yêu cầu khác
                </button>
              </div>
            ) : (
              <form className="form" onSubmit={onSubmit}>
                <div className="two-col">
                  <div className="field">
                    <label htmlFor="name">Họ và tên</label>
                    <input id="name" required placeholder="Nguyễn Văn A" />
                  </div>
                  <div className="field">
                    <label htmlFor="org">Đơn vị / tổ chức</label>
                    <input id="org" placeholder="Văn phòng UBND…" />
                  </div>
                </div>
                <div className="two-col">
                  <div className="field">
                    <label htmlFor="email">Email</label>
                    <input id="email" type="email" required placeholder="email@donvi.gov.vn" />
                  </div>
                  <div className="field">
                    <label htmlFor="phone">Số điện thoại</label>
                    <input id="phone" placeholder="09xx xxx xxx" />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="need">Nhu cầu quan tâm</label>
                  <select id="need" defaultValue="">
                    <option value="" disabled>
                      Chọn nhu cầu…
                    </option>
                    <option>Demo phiên âm & biên bản tự động</option>
                    <option>Triển khai trong hạ tầng nội bộ</option>
                    <option>Báo giá theo quy mô đơn vị</option>
                    <option>Tích hợp theo yêu cầu</option>
                  </select>
                </div>
                <div className="field">
                  <label htmlFor="msg">Mô tả thêm</label>
                  <textarea id="msg" rows={4} placeholder="Mô tả ngắn về quy trình họp và mong muốn của bạn…" />
                </div>
                <button type="submit" className="btn btn-primary btn-lg">
                  Gửi yêu cầu demo
                </button>
              </form>
            )}
          </Reveal>

          <Reveal delay={120} className="contact-info">
            <div className="note">
              Ghi Âm Pro đang được triển khai cho các cơ quan, đơn vị tại Việt Nam. Vui lòng để
              lại thông tin để nhận tư vấn phù hợp với nghiệp vụ của bạn.
            </div>
            <div className="contact-item">
              <span className="ic">
                <IconMail size={20} />
              </span>
              <div>
                <b>Email</b>
                <span>lienhe@ghiampro.congchuc.ai</span>
              </div>
            </div>
            <div className="contact-item">
              <span className="ic teal">
                <IconPhone size={20} />
              </span>
              <div>
                <b>Hỗ trợ tư vấn</b>
                <span>Giờ hành chính, các ngày làm việc trong tuần</span>
              </div>
            </div>
            <div className="contact-item">
              <span className="ic violet">
                <IconPin size={20} />
              </span>
              <div>
                <b>Phạm vi triển khai</b>
                <span>Cơ quan hành chính, văn phòng, doanh nghiệp và ban quản lý dự án</span>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
